export default "__VITE_ASSET__BfZ1TEPK__"